import { render, staticRenderFns } from "./activity-star-pick-pop.vue?vue&type=template&id=af319204&scoped=true&"
import script from "./activity-star-pick-pop.vue?vue&type=script&lang=js&"
export * from "./activity-star-pick-pop.vue?vue&type=script&lang=js&"
import style0 from "./activity-star-pick-pop.vue?vue&type=style&index=0&id=af319204&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af319204",
  null
  
)

export default component.exports